import type {Logo} from "@/scripts/Common";

const createEmptyLogo = () => {
    const logo: Logo = {
        id: 0,
        format: '',
        data: '',
    }

    return logo;
}

const resetLogoObject = (originalObject: Logo, changedObject: Logo) => {
    changedObject.id = originalObject.id;
    changedObject.format = originalObject.format;
    changedObject.data = originalObject.data;
}

const logoHasChanges = (originalObject: Logo | undefined | null, changedObject: Logo | undefined | null) => {
    if(!originalObject) return changedObject !== null && changedObject !== undefined;
    if(!changedObject) return true;

    return changedObject.id !== originalObject.id
        || changedObject.format !== originalObject.format
        || changedObject.data !== originalObject.data;
}

export {
    createEmptyLogo,
    resetLogoObject,
    logoHasChanges
}
